import { createSlice } from "@reduxjs/toolkit";
import { bookmarkGet } from "reduxStore/actions/bookmark";

const initialState = {
    userLoading: false,
    bookmarks: [],
    error: null,
};

const bookmarkSlice = createSlice({
    name: 'bookmark',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(bookmarkGet.fulfilled, (state, action) => {
                state.userLoading = false;
                state.bookmarks = action.payload.data;
            })
            .addCase(bookmarkGet.pending, (state) => {
                state.userLoading = true;
                state.error = null;
            })
            .addCase(bookmarkGet.rejected, (state, action) => {
                state.userLoading = false;
                state.error = action.payload;
            });
    }
});

export default bookmarkSlice.reducer;